//BUYERS Listing
export const FETCH_VOID_TICKET_LISTING_FAILURE = 'FETCH_VOID_TICKET_LISTING_FAILURE';
export const FETCH_VOID_TICKET_LISTING_SUCCESS = 'FETCH_VOID_TICKET_LISTING_SUCCESS';

export const RESET = 'RESET';
